export default __webpack_public_path__ + "static/media/element_72.8cf79ae5.jpg";